export enum ToastStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export default ToastStatus;
